<template>
  <BaseModal :modal-id="modalId" :title="title" :css-classes="cssClasses" :showFooter="false">
    <div class="mb-1 mt-2 mb-md-3 mt-md-4">
      <div v-if="options" class="row">
        <FormOption v-for="option in options"
                    :key="option"
                    @toggled="toggled"
                    :selected="selectedOption"
                    :option="option"
                    :wrapper-style="optionWrapperStyle"/>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "./BaseModal.vue";
import FormOption from "../FormOption.vue";

export default {
  name: 'SingleSelectionModal',

  emits: ["selected"],

  components: {
    BaseModal,
    FormOption
  },

  props: {
    options: {
      type: Array,
      required: true
    },

    title: {
      type: String,
      default: '',
    },

    modalId: {
      type: String,
      default: () => `modal-id-${Math.random().toString(36).slice(7)}`,
    },

    cssClasses: {
      type: Array,
      default: () => []
    },

    optionWrapperStyle: {
      type: String,
      default: "col-12 col-sm-4 col-md-4 col-lg-3 mb-1"
    },

    // The modal tracks selectedOption in local state, which persists between openings.
    // When a value is pre-filled (e.g. edit mode or VIN lookup), the parent sets it via
    // the store but the modal's local state stays empty. Pass the current value here so
    // it gets synced into selectedOption each time the modal opens.
    savedOption: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      selectedOption: {},
    }
  },

  computed: {
    openModalId() {
      return this.$store.state.ModalStore.openedModalId;
    },
  },

  watch: {
    openModalId(value) {
      if (value === this.modalId) {
        this.selectedOption = this.savedOption || {};
      }
    },
  },

  methods: {
    toggled(value) {
      this.selectedOption = value
      this.$emit('selected', this.selectedOption)
      this.$store.dispatch('ModalStore/closeModal')
    },
  },
}
</script>